import Botao from '@/components/Botao';
import CampoSeletor from '@/components/Formulario/CampoSeletor';
import HBox from '@/components/layout/HBox';
import { useDebounce } from '@/hooks/useDebounce';
import { mdiPlus } from '@mdi/js';
import axios from 'axios';
import { useState } from 'react';
import { useQuery } from 'react-query';

type CampoSeletorClienteProps = {
  onNovoCliente?: () => void;
  [key: string]: any;
};
export const CampoSeletorCliente = ({
  onNovoCliente,
  ...params
}: CampoSeletorClienteProps) => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);

  const q = useQuery(['cliente/box', debouncedSearch], async () => {
    const result = await axios.get('/api/cliente/box?nome=' + encodeURIComponent(debouncedSearch));
    return result.data.result;
  });
  const options = q.data?.map((c: any) => ({
    id: c.id,
    label: <div>
      <span>{c.nome + (c.sobrenome ? ` ${c.sobrenome}` : '')}</span>
      {c.empresa && <span style={{ fontSize: '0.8rem', fontStyle: 'italic', color: 'var(--tc-color-gray-500' }}>
        {' '} / {c.empresa.nome_fantasia || c.empresa.razao_social}
      </span>}
    </div>
  })) || [];
  return (
    <HBox style={{ alignItems: 'flex-end' }}>
      <CampoSeletor
        {...params}
        options={options}
        loadingState={q.status}
        initialSearch={search}
        onChangeSearch={setSearch}
        hasRemoteSearch
      />
      {onNovoCliente && (
        <Botao
          variant="outline-primary"
          title="Novo Cliente"
          onClick={onNovoCliente}
          icon={mdiPlus}
        />
      )}
    </HBox>
  );
};
